import * as React from "react";
import { Image } from "@/components/atoms/Image";
import { Skeleton } from "@/components/atoms/Skeleton";
import { getImageUrl } from "@/components/utils/VendorProfile/VendorProfile.utils";
import { VendorProfileSkeletonCard } from "./VendorProfileSkeletonCard";

export interface HorizontalVendorProfileCardProps {
  zone1: React.ReactNode;
  zone2: React.ReactNode;
  zone3: React.ReactNode;
  TLZone?: React.ReactNode;
  TRZone?: React.ReactNode;
  image: string;
  imageAlt?: string;
  isLoading?: boolean;
}

export const HorizontalVendorProfileCard = ({
  zone1,
  zone2,
  zone3,
  TLZone,
  TRZone,
  image,
  imageAlt = "",
  isLoading = false,
}: HorizontalVendorProfileCardProps) => {
  if (isLoading) {
    return <VendorProfileSkeletonCard />;
  }

  return (
    <div className="md:tw-flex tw-gap-32 tw-w-full">
      <div className="tw-aspect-[5/4] md:tw-w-[256px] md:tw-h-[205px] tw-rounded-4 tw-overflow-hidden tw-shrink-0 tw-relative">
        <Image
          width={256}
          height={205}
          src={getImageUrl(image)}
          alt={imageAlt}
          errorFallback={<Skeleton classNames="tw-w-full tw-h-full" />}
        />
        {TLZone && (
          <div className="tw-absolute tw-top-12 tw-left-12 tw-h-[24px]">
            {TLZone}
          </div>
        )}
        {TRZone && (
          <div className="tw-absolute tw-top-12 tw-right-12">{TRZone}</div>
        )}
      </div>
      <div className="tw-min-w-0 tw-my-20">
        <div className="tw-flex tw-justify-between tw-gap-12">
          <div className="tw-min-w-0 tw-w-full">{zone1}</div>
          <div className="tw-shrink-0">{zone2}</div>
        </div>
        <div className="tw-mt-16">{zone3}</div>
      </div>
    </div>
  );
};
